import React from "react";
import EmulatorConfigView from "./EmulatorConfigView";

export default function VistaComunicaciones() {
  return (
    <EmulatorConfigView
      subsystem="COMMS"
      title="Comunicaciones"
      icon="📶"
      description="Configura RSSI, frecuencia y SNR usando los generadores definitivos del PIC de Comunicaciones."
    />
  );
}
